module.exports = __webpack_public_path__ + "img/success.1dce84e4.png";